import React from 'react';

import { ContainerRow, IContainerRow } from './styles';

const TableRow: React.FC<IContainerRow> = ({ children, ...rest }) => {
  return <ContainerRow {...rest}>{children}</ContainerRow>;
};

export default TableRow;
